import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgWizardService } from 'ng-wizard';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { ToastClientService } from "src/app/services/toast/toast-client.service";
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
@Component({
  selector: 'app-create-crown',
  templateUrl: './create-crown.component.html',
  styleUrls: ['./create-crown.component.scss']
})
export class CreateCrownComponent implements OnInit {
  @Output() createCartonData: EventEmitter<boolean> = new EventEmitter;

  @Input() crownCampaignId = "";
  formGroup;
  campaignDetail: any;
  submitted: boolean = false
  currentDay: any;


  constructor(
    private ngWizardService: NgWizardService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toast: ToastClientService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
  ) {
  }

  ngOnInit() {
    this.campaignDetail = JSON.parse(localStorage.getItem('crown_collection'))

    this.currentDay = moment().format("YYYY-MM-DD")


    let data = {}
    this.formDetail(data)
    console.log(this.crownCampaignId)
    // debugger
    if (this.crownCampaignId != '0') {
      this.getCampaignDetail();
    }
  }

  formDetail(data) {

    this.formGroup = this.fb.group({
      campaign_title: new FormControl(data.crown_campaign_title, [Validators.required, Validators.pattern("[a-zA-Z0-9 ]*")]),
      month: new FormControl(`${data.year}-0${data.month}`, [Validators.required]),
      start_date: new FormControl(moment(data.start_date).format("YYYY-MM-DD"), [Validators.required]),
      end_date: new FormControl(moment(data.end_date).format("YYYY-MM-DD"), [Validators.required]),
      buffer_date: new FormControl(moment(data.buffer_date).format("YYYY-MM-DD"), [Validators.required]),
      is_caplimit_overall: new FormControl(0, [Validators.required]),
      crown_value_type: new FormControl(data.crown_value_type, [Validators.required]),
      min_limit: new FormControl(data.cap_min, [Validators.pattern("[0-9]*")]),
      max_limit: new FormControl(data.cap_max, [Validators.pattern("[0-9]*")]),
      voucher_name: new FormControl(data.voucher_name),
    });
  }

  get f() {
    return this.formGroup.controls;
  }

  getCampaignDetail() {

    this.apiService.get(this.apiConfig.getCampaignDetail + `?campaign_id=${this.crownCampaignId}&page_no=s`).subscribe((res: any) => {
      console.log(res.data.data.pagination[0])
      this.formDetail(res.data.data.pagination[0])

    })
  }

  submit(value) {
    this.submitted = true
    if (this.formGroup.invalid) {
      console.log(this.formGroup)
      this.toast.Error("All fields requerd")
      return
    }

    // this.campaignID.emit(1);

    let payload = {
      id: this.crownCampaignId != '0' ? this.crownCampaignId : '',
      campaign_title: value.campaign_title,
      month: moment(value.month).format('MM'),
      year: moment(value.month).format("YYYY"),
      cap_min: value.min_limit,
      cap_max: value.max_limit,
      crown_value_type: value.crown_value_type,
      voucher_name: value.voucher_name,
      caplimit_overall: value.is_caplimit_overall,
      start_date: value.start_date,
      end_date: value.end_date,
      buffer_date: value.buffer_date
    }
    console.log(payload)

    let url = this.crownCampaignId != '0' ? this.apiConfig.updateCrown : this.apiConfig.createCrown
    this.apiService.post(url, payload).subscribe((res: any) => {
      console.log(res)
      let crown_collection = {
        is_edit: this.campaignDetail.is_edit,
        create: 1,
        whitelist: 1,
        points_config: this.campaignDetail.points_config,
        target: this.campaignDetail.target,
        campaign_id: res.body.data.campaign_id
      }
      localStorage.setItem("crown_collection", JSON.stringify(crown_collection))
      this.createCartonData.emit(true);

    })
  }

  setValidation(field_name, value) {

    if (field_name == 'is_caplimit_overall' && value.is_caplimit_overall == 1) {
      this.formGroup.controls["min_limit"].setValidators(Validators.required);
      this.formGroup.controls["min_limit"].updateValueAndValidity();

      this.formGroup.controls["max_limit"].setValidators(Validators.required);
      this.formGroup.controls["max_limit"].updateValueAndValidity();
    }
    else if (field_name == 'is_caplimit_overall' && value.is_caplimit_overall == 0) {
      this.formGroup.controls["min_limit"].clearValidators();
      this.formGroup.controls["min_limit"].updateValueAndValidity();
      this.formGroup.controls["min_limit"].setErrors(null);

      this.formGroup.controls["max_limit"].clearValidators();
      this.formGroup.controls["max_limit"].updateValueAndValidity();
      this.formGroup.controls["max_limit"].setErrors(null);
    }
    else if (field_name == 'crown_value_type' && value.crown_value_type == 2) {
      this.formGroup.controls["voucher_name"].setValidators(Validators.required);
      this.formGroup.controls["voucher_name"].updateValueAndValidity();
    }
    else if (field_name == 'crown_value_type' && value.crown_value_type == 1) {
      this.formGroup.controls["voucher_name"].clearValidators();
      this.formGroup.controls["voucher_name"].updateValueAndValidity();
      this.formGroup.controls["voucher_name"].setErrors(null);
    }

  }

}